/* eslint-disable */
/* eslint-disable @typescript-eslint/no-var-requires */

import * as React from "react";
import { Button } from "@material-ui/core";

type ClickEvent<ElementType> = React.MouseEvent<ElementType, MouseEvent>;
type EventListener<EventType> = (event: EventType) => void;
type action = "download" | "delete" | "retry" | "remove" | "add"| undefined;

const getImage = (name: string): string => {
  return require(`../../images/${name}`);
};

const deleteImg = getImage("Delete.svg");
const removeImg = getImage("close_icon.svg");
const downloadImg = getImage("download.png");
const retryImg = getImage("Reset.svg");
const addImg = getImage("add.svg");

export interface ActionButtonProps {
  text: string;
  action: action;
  onClick: EventListener<ClickEvent<HTMLElement>>;
  disabled?: boolean;
  styles?: React.CSSProperties;
  testId?: string;
}

export const getImageSrc = (action: action) => {
  switch (action) {
    case "download":
      return downloadImg;
    case "delete":
      return deleteImg;
    case "retry":
      return retryImg;
    case "remove":
      return removeImg;
    case "add":
      return addImg;
  }
};

// action button
export const ActionButton: React.FunctionComponent<ActionButtonProps> = props => {
  const { onClick, text, testId, action, styles, ...remainingProps } = props;
  let imgSrc = getImageSrc(action);
  let disabled = props.disabled;
  disabled = disabled ? disabled : false;

  return (
    <Button
      variant="contained"
      color="primary"
      size="small"
      style={{
        ...styles
      }}
      onClick={onClick}
      {...remainingProps}
      disabled={disabled}
      data-testid={testId}
      startIcon={<img src={imgSrc} alt="Browse" />}
    >
      {text}
    </Button>
  );
};
